// Changes 1000 -> 1K, 1000000 -> 1M
function numberAbbreviator(number) {
  const parsed = parseInt(number)

  if (parsed > 10000000) {
    return (parsed / 1000000).toFixed(0) + "M"
  } else if (parsed > 1000000) {
    return (parsed / 1000000).toFixed(1) + "M"
  } else if (parsed > 10000) {
    return (parsed / 1000).toFixed(0) + "K"
  } else if (parsed > 1000) {
    return (parsed / 1000).toFixed(1) + "K"
  } else {
    return parsed
  }
}

angular.module('clientDashboardApp').filter('numberAbbreviator', () => numberAbbreviator);

export {numberAbbreviator}
